import React from "react"
import { Link } from "gatsby"

import { rhythm, scale } from "../utils/typography"
import Navbar from './Navbar'
import SideDrawer from './SideDrawer'

import '../styles/layout.css'
import ContactForm from "./ContactForm"

class Layout extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      toggleDrawer: false,
      isTop: true,
      form: false
    };
  }


  componentDidMount() {
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 20;
      if (isTop !== this.state.isTop) {
        this.setState({ isTop })
      }
    });
  }

  toggleDrawer = () => {
    this.setState((prevState) => {
      return { toggleDrawer: !prevState.toggleDrawer }

    })
  }


  toggleForm = () => {
    this.setState({ form: true })
  }

  closeForm = () => {
    this.setState({ form: false })
  }


  render() {
    let drawer = null
    if (this.state.toggleDrawer) {
      drawer = <SideDrawer toggleDrawer={this.toggleDrawer} />
    }



    const { location, title, children } = this.props
    const rootPath = `${__PATH_PREFIX__}/`
    let header

    if (location.pathname === rootPath) {
      header = (
        <h1
          style={{
            ...scale(1.5),
            marginBottom: rhythm(1.5),
            marginTop: 0,
          }}
        >
          <Link
            style={{
              boxShadow: `none`,
              textDecoration: `none`,
              color: `inherit`,
            }}
            to={`/`}
          >
            {title}
          </Link>
        </h1>
      )
    } else {
      header = (
        <h3
          style={{
            fontFamily: `Montserrat, sans-serif`,
            marginTop: 0,
          }}
        >
          <Link
            style={{
              boxShadow: `none`,
              textDecoration: `none`,
              color: `inherit`,
            }}
            to={`/`}
          >
            {title}
          </Link>
        </h3>
      )
    }
    return (
      <div style={{ height: '100%' }}>
        {drawer}
        <Navbar toggleDrawer={this.toggleDrawer} scroll={this.state.isTop} />
        <div>
          <form>

          </form>
        </div>
        <div
          style={{
            marginLeft: `auto`,
            marginRight: `auto`,
            maxWidth: rhythm(24),
            padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
            marginTop: "5%"
          }}
        >
          <header>{header}</header>
          <main>{children}</main>
        </div>
        <ContactForm form={this.state.form} closeForm={this.closeForm} />
        <div className='button__container'>
          <img onClick={() => {
            this.toggleForm()
          }} className={this.state.form ? 'button__hide' : 'button'} src={require('../../static/img/contact.png')} />
        </div>
        <footer className='footer'>
          <div style={{ flexDirection: 'column' }}>
            <div>
              <a href='https://www.linkedin.com/company/activebuildings/'>
                <img style={{ marginRight: '0.5rem', marginBottom: 0, padding: 0 }} src={require('../../static/img/linkedin-16.ico')} />
              </a>
              <a href='https://www.facebook.com/ActiveBuildings.in/'>
                <img style={{ marginRight: '0.5rem', marginBottom: 0, padding: 0 }} src={require('../../static/img/facebook-3-16.ico')} />
              </a>
              <a href='https://twitter.com/active_iaq'>
                <img style={{ marginBottom: 0, padding: 0 }} src={require('../../static/img/twitter-16.ico')} />
              </a>
            </div>
            <div>
              <p>
                ©2019 PiRhoAlpha Research. All Rights Reserved
            </p>
            </div>
          </div>
          <div>

          </div>
        </footer>
      </div>
    )
  }
}

export default Layout
